export default {
  bind (el, binding) {
    let scriptEl = document.createElement('script')
    scriptEl.type = 'application/ld+json'
    if (el.ownerDocument.body.firstElementChild.tagName !== 'SCRIPT') {
      el.ownerDocument.body.insertBefore(
        scriptEl,
        el.ownerDocument.body.firstChild
      )
    } else {
      el.ownerDocument.body.insertBefore(
        scriptEl,
        el.ownerDocument.body.firstChild.nextSibling
      )
    }
  },
  update (el, binding) {
    let scriptEl = document.querySelector('script[type="application/ld+json"]')
    const content = JSON.stringify(binding.value)
    scriptEl.innerHTML = content
  },
  unbind (el, binding) {
    let scriptEl = document.querySelector('script[type="application/ld+json"]')
    el.ownerDocument.body.removeChild(scriptEl)
  }
}



// WEBPACK FOOTER //
// ./src/utilities/json-ld.js